<main class="about-page">
  <pwj-about-section id="team"></pwj-about-section>
  <!-- <pwj-vision-section></pwj-vision-section> -->
<!--  <pwj-services-section></pwj-services-section>-->
  <!-- <pwj-team-members-section></pwj-team-members-section> -->
  <!-- <pwj-result-section></pwj-result-section> -->
  @if (faqData) {
    <section class="about-page__faq-wrap">
      <pwj-faq-section [faqData]="faqData" [verticalMargin]="false"></pwj-faq-section>
    </section>
  }
</main>
